// Copyright 2005-2007 David Caldwell <david@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;

solitaire["14out"] = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = this.options.decks;
        this.discard = new this.discard_pile("discard", this);
        this.tableau = [];
        for (var c=1; c<=12; c++) {
            this.tableau.push(new this.tableau_pile("tableau"+c, this));
        }
    }
    valid_options = { decks: option_def("number", 1, "Number of decks to use") };

    discard_pile = class extends pile {
        accept_stacks = false;
        accept(card) { return false; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return false; }
    };

    tableau_pile = class extends pile {
        constructor(div,game) {
            super(div,game,false);
        }
        accept(card) { return this.pile.length && this.top().rank + card.rank == 14 ? 2 : 0; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = 0;
        maxstack = 5;
        split_move(start, n, from) {
                    return [{from:from, to:this,              fstart:start,              n:1, tanimate:false},
                            {from:this, to:this.game.discard, fstart:this.top_index()+1, n:1, internal:true},
                            {from:this, to:this.game.discard, fstart:this.top_index()+0, n:1, internal:true}];
        }
    };


    deal(deck) {
	    this.dealing = true;
            this.deck = deck;
            for (var c in this.deck) {
                this.deck[c].face = up;
                this.tableau[c%this.tableau.length].push(this.deck[c]);
            }
	    this.dealing = false;
    }

    fix_replay_move(moves) {
            return moves.replace(/^(.)0(.)0/, "$1$2"); // 2 cards to discard -> First card onto the second card (discard is implied).
    }

    is_complete() {
            for (var i in this.tableau)
                if (this.tableau[i].pile.length) {
                    for (var j in this.tableau)
                        if (i != j && this.tableau[j].pile.length &&
                            this.tableau[i].accept(this.tableau[j].top()))
                            return NOT_COMPLETE;
                }
            for (var i in this.tableau)
                if (this.tableau[i].pile.length)
                    return GAME_OVER;
            return WON;
    };

    score() {
            return 52 - this.count_cards_in(this.tableau);
    };

    layout = grid(["discard", "tableau1", "tableau2", "tableau3", "tableau4",  "tableau5",  "tableau6" ],
                  [{ y: +1 },
                   undefined, "tableau7", "tableau8", "tableau9", "tableau10", "tableau11", "tableau12"]);
}

module.exports = solitaire["14out"];
// Copyright 2005-2007 David Caldwell <david@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var options = require('./options'), option_def=options.option_def;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;

solitaire["14out"] = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = this.options.decks;
        this.discard = new this.discard_pile("discard", this);
        this.tableau = [];
        for (var c=1; c<=12; c++) {
            this.tableau.push(new this.tableau_pile("tableau"+c, this));
        }
    }
    valid_options = { decks: option_def("number", 1, "Number of decks to use") };

    discard_pile = class extends pile {
        accept_stacks = false;
        accept(card) { return false; }
        xoffset = 0;
        yoffset = 0;
        can_drag(index) { return false; }
    };

    tableau_pile = class extends pile {
        constructor(div,game) {
            super(div,game,false);
        }
        accept(card) { return this.pile.length && this.top().rank + card.rank == 14 ? 2 : 0; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = 0;
        maxstack = 5;
        split_move(start, n, from) {
                    return [{from:from, to:this,              fstart:start,              n:1, tanimate:false},
                            {from:this, to:this.game.discard, fstart:this.top_index()+1, n:1, internal:true},
                            {from:this, to:this.game.discard, fstart:this.top_index()+0, n:1, internal:true}];
        }
    };


    deal(deck) {
	    this.dealing = true;
            this.deck = deck;
            for (var c in this.deck) {
                this.deck[c].face = up;
                this.tableau[c%this.tableau.length].push(this.deck[c]);
            }
	    this.dealing = false;
    }

    fix_replay_move(moves) {
            return moves.replace(/^(.)0(.)0/, "$1$2"); // 2 cards to discard -> First card onto the second card (discard is implied).
    }

    is_complete() {
            for (var i in this.tableau)
                if (this.tableau[i].pile.length) {
                    for (var j in this.tableau)
                        if (i != j && this.tableau[j].pile.length &&
                            this.tableau[i].accept(this.tableau[j].top()))
                            return NOT_COMPLETE;
                }
            for (var i in this.tableau)
                if (this.tableau[i].pile.length)
                    return GAME_OVER;
            return WON;
    };

    score() {
            return 52 - this.count_cards_in(this.tableau);
    };

    layout = grid(["discard", "tableau1", "tableau2", "tableau3", "tableau4",  "tableau5",  "tableau6" ],
                  [{ y: +1 },
                   undefined, "tableau7", "tableau8", "tableau9", "tableau10", "tableau11", "tableau12"]);
}

module.exports = solitaire["14out"];
